import { FC, ReactNode } from "react";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";

interface WidgetLayoutProps {
  children?: ReactNode;
}

const WidgetLayout: FC<WidgetLayoutProps> = () => {
  return (
    <Box
      sx={{
        // borderColor: `${PureLightThemeCaaS.colors.alpha.gray[50]}`,
        // borderWidth: 1,
        // borderStyle: "solid",
        // borderRadius: 0,
        height: "100%",
        width: "100%",
      }}
    >
      <Outlet />
    </Box>
  );
};

export default WidgetLayout;
